<template>
  <ok-modal
    :value="value"
    size="sm"
    dialog-class="tables-modal"
    :title="$t('queues.assign-table', [tableLabel(1).toLowerCase()])"
    @change="loading ? null : $emit('input', $event)"
  >
    <error-alert :error="error" />
    <label>{{ $t('queues.choose-table') }}</label>
    <v-select
      v-model="table"
      :dir="isRTL ? 'rtl' : 'ltr'"
      input-id="id"
      :options="tables"
      :multiple="false"
      :plcaeholder="$t('queues.choose-table', [tableLabel(1).toLowerCase()])"
      :clearable="false"
      label="name"
      class="select-size-lg filter-select"
    />
    <template #actions>
      <div class="d-flex justify-content-center align-items-center">
        <b-button
          variant="outline-dark"
          class="mx-1"
          @click="$emit('close')"
        >
          {{ $t('forms.cancel') }}
        </b-button>
        <b-button
          variant="dark"
          :disabled="loading || !table.id"
          @click="submit()"
        >
          <span :class="{'pr-1': loading}">{{ $t('forms.save') }}</span>
          <b-spinner
            v-if="loading"
            small
          />
        </b-button>

      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import OkModal from '@/@okmenu/components/modals/OkModal'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import BusinessTypeMixin from '@/mixins/business-type-mixin'

export default {
  name: 'AssignTableModal',
  components: {
    ErrorAlert,
    OkModal,
    BButton,
    BSpinner,
    vSelect,
  },
  mixins: [BusinessTypeMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'queues',
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      table: {},
      tables: [],
    }
  },
  watch: {
    item(item) {
      this.table = { id: item.table_id, name: item.table }
    },
    value() {
      this.error = null
    },
  },
  mounted() {
    this.$nextTick(() => { this.tables = this.$store.getters[`${this.type}/tables`] })
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        const response = await this.$store.dispatch(`${this.type}/UPDATE`, { table_id: this.table?.id, id: this.item.id })
        if (response?.response === 202) {
          this.$emit('updated', (response?.response === 202))
          this.$notifySuccess(response.message)
        } else {
          this.$notifyError(response.message)
        }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
